export const defaultFilterBenefits = () => {
    return {
        company_id: "",
        limit: 5,
        page: 1,
        search: "",
        in_use: "",
        payment: "",
        manufacturer_id: "",
        benefit: "",
        date_updated: "",
        date_document: "",
        location_id: null,
    };
};

export const defaultProductBenefits = () => {
    return [];
};

export const defaultAccompanied = () => {
    return {};
};

export default {
    productBenefits: defaultProductBenefits(),
    accompanied: defaultAccompanied(),
    filterBenefits: defaultFilterBenefits(),
};
